<template>
  <section class="about-descriptions">
    <p class="about-descriptions__title">
      キモチの数だけギフトを贈ろう
    </p>
    <div class="about-descriptions__text-lines">
      <div class="about-descriptions__paragraph">
        <p class="about-descriptions__text">
          ありがとう、おつかれさま、おめでとう……
        </p>
      </div>
      <div class="about-descriptions__paragraph">
        <p class="about-descriptions__text">
          日々、私たちの心に浮かぶ、いろんなキモチ。
        </p>
        <div class="about-descriptions__small-paragraph">
          <p class="about-descriptions__text">
            ちゃんと届けられたら、
          </p>
          <p class="about-descriptions__text">
            うれしいのは相手以上に、自分かもしれない。
          </p>
        </div>
      </div>
      <div class="about-descriptions__paragraph">
        <div class="about-descriptions__small-paragraph">
          <p class="about-descriptions__text">
            時間がなくて会えない人に、
          </p>
          <p class="about-descriptions__text">
            遠く離れて暮らす人に、
          </p>
        </div>
        <p class="about-descriptions__text">
          面と向かうと照れちゃうあの人にも。
        </p>
      </div>
      <p class="about-descriptions__text">
        gifteeで気軽に贈ってみませんか？
      </p>
      <button class="about-descriptions-button" @click="onClickStartButton">
        <span class="about-descriptions-button__text">さっそくはじめる</span>
        <ArrowForwardWhite class="about-descriptions-button__icon" />
      </button>
    </div>
  </section>
</template>

<script>
import ArrowForwardWhite from '../../../atoms/svg_icons/ArrowForwardWhite'
export default {
  components: { ArrowForwardWhite },
  methods: {
    onClickStartButton() {
      location.href = '/'
    }
  }
}
</script>

<style lang="scss" scoped>
.about-descriptions {
  padding: 80px 0;
  letter-spacing: 0.06em;
  background-position: center;
  background-image: url('../../../../../../images/abouts/bg_image/p0044_l.jpeg');
  background-repeat: no-repeat;
  background-size: cover;

  @media all and (max-width: $pc-width  - 1) {
    padding: 40px;
  }

  &__title {
    padding-bottom: 40px;
    font-weight: bold;
    font-size: 2.4rem;
    line-height: 1.6;
    text-align: center;
    color: $black;

    @media all and (max-width: $pc-width  - 1) {
      font-size: 1.8rem;
    }

    @media all and (max-width: $sp-iphone5-width) {
      font-size: 1.6rem;
    }
  }

  &__text-lines {
    margin: auto;
  }

  &__paragraph {
    margin-bottom: 28px;
  }

  &__small-paragraph {
    display: flex;
    justify-content: center;

    @media all and (max-width: $base-contents-width - 1) {
      display: block;
    }
  }

  &__text {
    font-weight: bold;
    font-size: 1.4rem;
    line-height: 2;

    @media all and (max-width: $pc-width  - 1) {
      font-size: 1.2rem;
    }

    @media all and (max-width: $sp-iphone5-width) {
      font-size: 1rem;
    }
  }

  &-button {
    @extend %hover-common;
    margin: 24px auto 0;
    padding: 12px 24px;
    background: $black;
    border-radius: 4px;
    display: none;
    align-items: center;
    cursor: pointer;

    @media all and (max-width: $pc-width  - 1) {
      display: flex;
    }

    &__text {
      font-weight: bold;
      font-size: 1.4rem;
      line-height: 2;
      letter-spacing: 0.06em;
      color: $white;

      @media all and (max-width: $sp-iphone5-width) {
        font-size: 1.2rem;
      }
    }

    &__icon {
      width: 24px;

      path {
        fill: $white;
      }
    }
  }
}
</style>
